var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('titleSection'),_c('filterSection',{staticClass:"my-2"}),_c('tableSection')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }